import { Navigate, useLocation } from 'react-router-dom';
import { useAppContext } from '../contexts/AppContext';
import { AUTH_TOKEN, LINKS } from '../constants';

/**
 * PrivateRoute is a component that protects the specified children routes
 * by ensuring that the user is logged in before rendering them.
 *
 * @component
 * @prop {JSX.Element} children - The children to be protected.
 * @returns {JSX.Element | Navigate} The JSX element representing the children routes if the user is logged in,
 *   or a Navigate component redirecting to the login page if the user is not logged in.
 */
export const PrivateRoute = ({ children }: { children: JSX.Element }) => {
  const { isAppUserLoggedIn } = useAppContext(); //, currentUser } = useAppContext();
  const location = useLocation();
  const token = sessionStorage.getItem(AUTH_TOKEN) || localStorage.getItem(AUTH_TOKEN);

  if (!token && !isAppUserLoggedIn) {
    return <Navigate to={LINKS.LOGIN_LINK} state={{ from: location }} replace />;
  }
  // else if (!currentUser) {
  //   return <AppLoader />;
  // }
  else {
    return children;
  }
};
